"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import { resultPostprocessing2 } from "@/components/fetcher/fetchInterceptor"

const ROOT = process.env.NEXT_PUBLIC_ROOT

// /intro에서 서버사이드 쿠키 초기화를 위한 fetch
const fetchClientClearTokens = () => {
  return fetchInterceptorInClient(
    {
      method: "delete",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/account/authenticate/tokens/clear`).then(resultPostprocessing2)
}

export default fetchClientClearTokens
